export default __webpack_public_path__ + "static/step7-587b5ae3cd8c473e31fad1250852eec2.svg";